import { render } from "./RawMaterialAreaComponent.vue?vue&type=template&id=7970a1ce&scoped=true"
import script from "./RawMaterialAreaComponent.vue?vue&type=script&lang=js"
export * from "./RawMaterialAreaComponent.vue?vue&type=script&lang=js"

import "./RawMaterialAreaComponent.vue?vue&type=style&index=0&id=7970a1ce&scoped=true&lang=css"

import exportComponent from "D:\\Cotizador Frontend\\dyc_cotizador_frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7970a1ce"]])

export default __exports__